import type {GetStaticProps} from 'next';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {LandingSections} from '@tempo/landing';
import {
	HeroBlock,
	Testimonials,
	Offer,
	Satisfaction,
} from '@app/views/features/reviews';
import {TempoLandingPage} from '@app/components/layout/LandingPage';
import type {LandingProps} from '@app/types/next';
import {useTranslation} from '@app/hooks/use-translation';
import {getFooterLinksPerLang} from '@app/modules/ssg-data/unlogged-data';

const ReviewsPage: React.FC<LandingProps> = () => {
	const {t} = useTranslation({ns: ['reviews']});

	const pageTitle = t('reviewslandingpage_text_seotitle_standalone-web');
	const pageDescription = t(
		'reviewslandingpage_text_seodescription_standalone-web',
	);
	return (
		<TempoLandingPage title={pageTitle} description={pageDescription}>
			<LandingSections>
				<HeroBlock />
				<Testimonials />
				<Offer />
				<Satisfaction />
			</LandingSections>
		</TempoLandingPage>
	);
};

export const getStaticProps: GetStaticProps<LandingProps> = async ({
	locale = '',
	locales = [],
}) => {
	const translations = await serverSideTranslations(locale, [
		'reviews',
		'common',
	]);
	return {
		props: {
			...translations,
			dehydratedState: {
				...(await getFooterLinksPerLang({locale, locales})),
			},
			tracking: {
				pagecategory: 'review',
				pagename: 'review',
				cdpViewId: 'reviews',
			},
		},
		revalidate: 15 * 60,
	};
};

export default ReviewsPage;
